import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDStack } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import { OtherOptions } from 'Views/Authentication/Components/OtherOptions';
import {
  AuthenticationLayout,
  AuthenticationLayoutForm,
  LoginWithPasskeyButton,
  AuthenticationSubmitButton,
} from '../../Components';

export const AuthLoginEmailLayout = ({ setAuthCollection }) => {
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();

  return (
    <AuthenticationLayout>
      <AuthenticationLayoutForm
        id={'login-email-form'}
        onSubmit={onSubmit}
        errors={unsourcedErrors}
      >
        <FDStack direction={'column'} spacing={2}>
          <MetaControlField attr={'emailAddress'} CustomProps={{ fullWidth: true }} {...dataAttrs('input-email')} />
          <AuthenticationSubmitButton />
          <OtherOptions resource={resource} relationships={[fr.relationships.passkeyLoginChallenge.name]} />
          <LoginWithPasskeyButton setAuthCollection={setAuthCollection} />
        </FDStack>
      </AuthenticationLayoutForm>
    </AuthenticationLayout>
  );
};
